<template>
  <el-dialog
    class="video-player"
    :class="device.isMobile ? 'video-player-mobile' : ''"
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    :destroy-on-close="true"
    :append-to-body="true"
    @close="closeHandle"
    style="z-index: 10000"
    v-if="dialogVisible"
  >
    <div class="video-box">
      <div class="player-box">
        <video
          id="myVideo"
          :src="videoList[playingIndex].url"
          width="100%"
          controls
          autoplay
          :poster="require('@/assets/images/common/video-poster-default.png')"
          webkit-playsinline="true"
          playsinline="true"
          controlsList="nodownload"
          x5-playsinline=""
          x-webkit-airplay="allow"
          x5-video-player-type="h5"
          x5-video-player-fullscreen=""
          x5-video-orientation="portraint"
          v-if="dialogVisible"
        ></video>
      </div>
      <div class="list-box">
        <div
          v-for="(item, index) in videoList"
          :key="item.key"
          class="video-item"
          :class="playingIndex == index ? 'video-item-active' : ''"
          @click="changePlayingVideo(index)"
        >
          <div class="video-cover">
            <el-image class="cover-image" :src="item.cover" fit="cover"></el-image>
          </div>
          <div class="video-title">{{ item.title }}</div>
        </div>
      </div>
      <div class="close-btn" @click="closeHandle">
        <span class="el-icon-circle-close"></span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
/*
视频集播放器
*/
export default {
  name: "videoPlayer",
  props: {
    dialogTitle: {
      type: String,
      default: "播放视频"
    },
    visible: {
      type: Boolean,
      default: false
    },
    videoList: {
      type: Array,
      default: () => {
        return [];
      }
    },
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
    }
  },
  data() {
    return {
      dialogVisible: false,
      playingIndex: 0,
    }
  },
  methods: {
    changePlayingVideo(index) {
      this.playingIndex = index
    },
    closeHandle() {
      let myVideo = document.getElementById('myVideo')
      myVideo.style.left = "-1000%"
      myVideo.pause()
      myVideo.removeAttribute('src')
      myVideo.load()
      myVideo.style.display = 'none'
      myVideo = null
      this.$nextTick(() => {
        setTimeout(() => {
          this.dialogVisible = false
          this.$emit('dialogClose')
        }, 100)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.video-player{
  text-indent: 0;

  .video-box{

    .player-box{
      width: 100%;
      height: 422rem;
      overflow: hidden;
      position: relative;

      video{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }

    .list-box{
      padding: 24rem 15rem;
      overflow: hidden;
      // overflow-x: scroll;
      white-space: nowrap;

      .video-item{
        width: 120rem;
        display: inline-block;
        margin-right: 10rem;

        .video-cover{
          width: 120rem;
          height: 150rem;
          display: flex;
          align-items: center;

          .cover-image{
            width: 120rem;
            height: 120rem;
          }
        }

        .video-title{
          width: 120rem;
          padding: 10rem;
          font-size: 16rem;
          line-height: 24rem;
          color: #fff;
          opacity: 0.65;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .video-item-active{
        width: 150rem;
        
        .video-cover{
          width: 150rem;
          height: 150rem;
          border: 5rem solid #0FC29A;
          box-sizing: border-box;

          .cover-image{
            width: 140rem;
            height: 140rem;
          }
        }
        
        .video-title{
          width: 150rem;
        }
      }
    }

    .close-btn{
      font-size: 40rem;
      color: #e3e3e3;
      position: absolute;
      bottom: -90rem;
      left: 50%;
      margin-left: -23rem;
      cursor: pointer;
    }
  }
}
/deep/.el-dialog{
  width: 750rem;
  background: rgba(0, 0, 0, 0.65);
  position: absolute;
  top: 50%;
  left: 50%;
  bottom: auto;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  min-height: auto;

  .el-dialog__header{
    display: none;
  }
  .el-dialog__body{
    padding: 0;
  }
}

.video-player-mobile{
  .video-box{
    .list-box{
      .video-item{
        .video-title{
          font-size: 20rem;
        }
      }
    }
  }
}
</style>